import * as React from "react";
import { forwardRef } from "react";
const SvgDevices = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M5.41675 18.2617L16.0419 15.4146",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6.04199 7.27734L8 6.72266",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.1846 12.215L15.3302 12.7583L15.9125 14.9317L16.5595 17.3465C16.8454 18.4134 16.2123 19.5101 15.1453 19.796L8.38385 21.6077C7.31692 21.8936 6.22025 21.2604 5.93436 20.1935L2.44031 7.15351C2.15442 6.08658 2.78759 4.9899 3.85452 4.70402L5.30341 4.31579L6.99378 3.86286L8.0397 3.58361",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20 2H10C8.89543 2 8 2.89543 8 4V7.38462V10C8 11.1046 8.89543 12 10 12H18H20C21.1046 12 22 11.1046 22 10V4C22 2.89543 21.1046 2 20 2Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15 9C16.1046 9 17 8.10457 17 7C17 5.89543 16.1046 5 15 5C13.8954 5 13 5.89543 13 7C13 8.10457 13.8954 9 15 9Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgDevices);
export default ForwardRef;
